module.exports = __webpack_public_path__ + "72a2fa7f3eef313295ce25e2d6a899aa.MP3";